import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all() {
    return BackendAPI('get', ApiRoutes.trialCourse.all());
  },
  create(data) {
    return BackendAPI('post', ApiRoutes.trialCourse.create(), data);
  },
  delete(id) {
    return BackendAPI('delete', ApiRoutes.trialCourse.delete(id));
  },
};
